import { UserRoles } from '@bandido/shared/types';
import { createMongoAbility, AbilityBuilder } from '@casl/ability';

// TODO: Definir con el quipo un sistema de roles escalables..
// NON-REGISTERED -> REGISTERED -> BASE -> AGENTS -> OPERATOR -> ADMINS...
// Y para casos de roles unicos.. crear su rol particular sin extender de los demás.

const ABILITES_PER_ROLE = {
  [UserRoles.HOTEL_BOOKER]: {
    create: 'Booking',
    manage: '',
    view: '',
  },
  [UserRoles.TESTER]: {
    create: '',
    manage: '',
    view: 'Tester',
  },
  [UserRoles.HOTEL_CONTENT_MODERATOR]: {
    create: '',
    manage: 'ContentManager',
    view: 'Dashboard',
  },
  [UserRoles.AGENTS]: {
    create: '',
    manage: ['Cases', 'Clients','SaleOrders'],
    view: ['Dashboard', 'Users', 'AgencySelector', 'Calls', 'TravelServices', 'Hotels'],
  },
  [UserRoles.OPERATORS]: {
    create: '',
    manage: ['Cases', 'Clients', 'SaleOrders', 'Agencies'],
    view: ['Dashboard', 'AgencySelector', 'Calls', 'TravelServices', 'Hotels'],
  } ,
  [UserRoles.ADMINS]: {
    create: ['Booking', 'User', 'CasePublicFilters'],
    manage: ['MarkupRules', 'ContentManager', 'Cases', 'Clients', 'Users', 'SaleOrders', 'Agencies', 'AgencyAdminTools','FlightIntegrations', 'HotelIntegrations'],
    view: ['Dashboard', 'Cart', 'Flights', 'Hotels', 'Cars', 'Explorer', 'Tester', 'AgencySelector', 'Calls', 'TravelServices'],
  },
};

export const getUserAbilities = (roles: UserRoles[]) => {
  const { can, build } = new AbilityBuilder(createMongoAbility);
  roles.forEach(role => {
    switch (role) {
    case UserRoles.HOTEL_BOOKER:
      can('create', ABILITES_PER_ROLE[UserRoles.HOTEL_BOOKER].create);
      can('manage', ABILITES_PER_ROLE[UserRoles.HOTEL_BOOKER].manage);
      can('view', ABILITES_PER_ROLE[UserRoles.HOTEL_BOOKER].view);
      break;
    case UserRoles.TESTER:
      can('create', ABILITES_PER_ROLE[UserRoles.TESTER].create);
      can('manage', ABILITES_PER_ROLE[UserRoles.TESTER].manage);
      can('view', ABILITES_PER_ROLE[UserRoles.TESTER].view);
      break;
    case UserRoles.HOTEL_CONTENT_MODERATOR:
      can('create', ABILITES_PER_ROLE[UserRoles.HOTEL_CONTENT_MODERATOR].create);
      can('manage', ABILITES_PER_ROLE[UserRoles.HOTEL_CONTENT_MODERATOR].manage);
      can('view', ABILITES_PER_ROLE[UserRoles.HOTEL_CONTENT_MODERATOR].view);
      break;
    case UserRoles.AGENTS:
      can('create', ABILITES_PER_ROLE[UserRoles.AGENTS].create);
      can('manage', ABILITES_PER_ROLE[UserRoles.AGENTS].manage);
      can('view', ABILITES_PER_ROLE[UserRoles.AGENTS].view);
      break;
    case UserRoles.OPERATORS:
      can('create', ABILITES_PER_ROLE[UserRoles.OPERATORS].create);
      can('manage', ABILITES_PER_ROLE[UserRoles.OPERATORS].manage);
      can('view', ABILITES_PER_ROLE[UserRoles.OPERATORS].view);
      break;
    case UserRoles.ADMINS:
      can('create', ABILITES_PER_ROLE[UserRoles.ADMINS].create);
      can('manage', ABILITES_PER_ROLE[UserRoles.ADMINS].manage);
      can('view', ABILITES_PER_ROLE[UserRoles.ADMINS].view);
      break;
    default:
      break;
    }
  });

  return build();
};
